var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics main"},[_c('ul',{staticClass:"tabs"},_vm._l((_vm.tab),function(v,k){return _c('li',{key:k,class:{tab:true,active:v.route_name===_vm.$route.name},on:{"click":function($event){return _vm.tabChange(v.route_name)}}},[_vm._v(_vm._s(v.name))])}),0),_c('div',{staticClass:"container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }